import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { SEARCH_QUERY_PARAM } from 'src/Libs/navigation/consts'
import { useQuery } from 'src/Hooks/useQuery'

interface ReturnProps {
  onChange: (value: string) => void
  filterQuery: string
  filterString: string
}
/**
 * hook that handles all the events regarding the search functions for each tab
 * @param searchProperty property that should be searched for by the search function
 * @returns onCHange function, filterQuery and filterString which was previously handled by every tab individually
 */
export const useFilteredInstallationsNavigation = (searchProperty: string): ReturnProps => {
  const query = useQuery()
  const searchQuery = query.get(SEARCH_QUERY_PARAM)
  const [filterString, setFilterString] = useState<string>(searchQuery ?? '')
  const [filterQuery, setFilterQuery] = useState('')
  const navigate = useNavigate()
  const location = useLocation()

  const onChange = (value: string): void => {
    /** Asterisks are added to support filtering with Wildcards */
    setFilterQuery(value ? `${searchProperty}=*${value}*` : '')
    setFilterString(value)
  }

  useEffect(() => {
    if (filterString === '') {
      navigate(location.pathname.split('?')[0], { replace: true })
      return
    }

    if (filterString !== undefined) {
      navigate(location.pathname + `?${SEARCH_QUERY_PARAM}=${filterString}`, { replace: true })
    }
  }, [filterString, navigate, location.pathname])
  return { onChange, filterQuery, filterString }
}
